
import {SET_ACTIVE_MODULE} from './_CONSTANTS';

export const setActiveModule = (moduleName) => {
  return {
    type: SET_ACTIVE_MODULE,
    payload: moduleName
  }
}